import { atsApiQuery } from '..';

export const departmentsApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getAtsDepartments: builder.query({
        providesTags: ['GetAtsDepartments'],
        transformResponse: (response) => response?.data?.departments,
        query: () => {
          return {
            method: 'get',
            url: `/ats_departments`,
          };
        },
      }),
      createParentDepartment: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload = {} }) => {
          const { params } = payload;
          return {
            method: 'post',
            url: `/ats_departments/create_root`,
            data: { ...params },
          };
        },
        invalidatesTags: (result) => {
          if (result?.[0]?.id) {
            return [{ type: 'GetAtsDepartments' }];
          }
          return [];
        },
      }),
      createChildDepartment: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload = {} }) => {
          const { params, parentId } = payload;
          return {
            method: 'post',
            url: `/ats_departments/${parentId}/create_child`,
            data: { ...params },
          };
        },
        invalidatesTags: (result) => {
          if (result?.[0]?.id) {
            return [{ type: 'GetAtsDepartments' }];
          }
          return [];
        },
      }),
      updateDepartment: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload = {} }) => {
          const { params, departmentId } = payload;
          return {
            method: 'put',
            url: `/ats_departments/${departmentId}`,
            data: { ...params },
          };
        },
        invalidatesTags: (result) => {
          if (result?.[0]?.id) {
            return [{ type: 'GetAtsDepartments' }];
          }
          return [];
        },
      }),
      moveDepartment: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload = {} }) => {
          const { params, departmentId } = payload;
          return {
            method: 'put',
            url: `/ats_departments/${departmentId}/move`,
            data: { ...params },
          };
        },
        invalidatesTags: (result) => {
          if (result?.[0]?.id) {
            return [{ type: 'GetAtsDepartments' }];
          }
          return [];
        },
      }),
      getDepartmentDependentCount: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload = {} }) => {
          const { departmentId } = payload;
          return {
            method: 'get',
            url: `/ats_departments/${departmentId}/dependent_count`,
          };
        },
      }),
      deleteDepartment: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload = {} }) => {
          const { departmentId, params } = payload;
          return {
            method: 'delete',
            url: `/ats_departments/${departmentId}/delete`,
            data: { ...params },
          };
        },
        invalidatesTags: () => [{ type: 'GetAtsDepartments' }],
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useGetAtsDepartmentsQuery,
  useCreateChildDepartmentMutation,
  useCreateParentDepartmentMutation,
  useUpdateDepartmentMutation,
  useMoveDepartmentMutation,
  useGetDepartmentDependentCountMutation,
  useDeleteDepartmentMutation,
} = departmentsApi;
